import { forwardRef, ReactNode } from 'react'
import { Button, ButtonProps } from './button'
import { Spinner } from './spinner'

export interface ButtonLoadingProps extends ButtonProps {
  isLoading: boolean
  loadingText?: string
  children: ReactNode
}

const defaultLoadingText = 'Please wait...'
const ButtonLoading = forwardRef<HTMLButtonElement, ButtonLoadingProps>(
  ({ isLoading, loadingText, children, ...props }, ref) => (
    <Button ref={ref} disabled={isLoading} {...props}>
      {isLoading ? (
        <>
          <Spinner />
          {loadingText ?? defaultLoadingText}
        </>
      ) : (
        children
      )}
    </Button>
  ),
)

ButtonLoading.displayName = 'ButtonLoading'

export default ButtonLoading
